import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MessageConfiguration from '../Templates/MessageConfiguration';
import UserList from '../Users/UserListTable';
import { useParams } from 'react-router-dom';
import { deleteDashboardMessage, getDashboardMessages, saveDashboardMessage } from '../communicationApi';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import { removeSpacing } from '../../../../Common/Sanitize/sanitizeReactQuill';

export interface MessageTemplate {
  MessageNum: number;
  MessageSubject: string;
  MessageBody: string;
  IsUserMessage: boolean
}

const DashboardMessage: React.FC = () => {
  const [isMessageConfigured, setIsMessageConfigured] = useState(false); // State to track when a template is selected
  const [messageList, setMessageList] = useState<string>(''); // Single string for selected message template
  const [configureDashboardMessage, setConfigureDashboardMessage] = useState<string>('');
  const [messageTemplates, setMessageTemplates] = useState<MessageTemplate[]>([]);
  const { tenant } = useParams<{ tenant: string }>();
  const { showSnackbar } = useSnackbar();
  const [selectedEmailId, setSelectedEmailId] = useState<number | null>(null)
  const [dashboardMessage, setDashboardMessage] = useState('');
  const tabName = 'Dashboard';




  const fetchDashboardMessages = async () => {
    try {
      const response = await getDashboardMessages(tenant)
      setMessageTemplates(response);

    } catch (error) {
      console.error('Error fetching email templates:', error);
    }
  };

  useEffect(() => {
    fetchDashboardMessages()
  }, [tenant])


  const handleSave = async (dashboardMessage: string, configureDashboardMessage: string, messageNum: number | null) => {
    try {
      const message = removeSpacing(configureDashboardMessage)
      const payLoad = {
        MessageSubject: dashboardMessage,
        MessageBody: message,
        MessageNum: messageNum ? messageNum : 0
      }
      const response = await saveDashboardMessage(tenant, payLoad)
      if (response) {
        showSnackbar(
          `User template has been ${messageNum ? 'updated' : 'created'}`,
          'success'
        );

        if (messageNum) {
          setMessageTemplates(preTemplates => preTemplates.map(template => (template.MessageNum === messageNum ? { ...template, MessageSubject: dashboardMessage, MessageBody: configureDashboardMessage } : template)))
        }
        else {
          setMessageTemplates(prevTemplates => [
            ...prevTemplates,
            { // Assuming response.data has the new message object structure
              MessageNum: response.MessageNum, // Adjust this based on your API response
              MessageSubject: dashboardMessage,
              MessageBody: configureDashboardMessage,
              IsUserMessage: true
            }
          ]);
        }
      }
    } catch (error) {
      showSnackbar(
        `Failed to ${messageNum ? 'update' : 'create'} the user template. Please try again.`,
        'error'
      );
      console.log('Error saving message configuration:', error)
    }


  };

  const handleDelete = async (id: number | null) => {
    if (typeof id !== "number") {
      return
    }
    try {
      const payLoad = {
        MessageNum: id
      }
      const response = await deleteDashboardMessage(tenant, payLoad)
      if (response) {
        showSnackbar('User template deleted successfully.', "success")
        setMessageTemplates(prevTemplates => prevTemplates.filter(template => template.MessageNum !== id));
      }
    } catch (error) {
      showSnackbar("Failed to delete user template. Please try again.", "error")
      console.log(error)
    }

  }

  const handleClearAll = ()=>{
    setMessageList('')
    setConfigureDashboardMessage('')
    setDashboardMessage('')
    setSelectedEmailId(null)
    setIsMessageConfigured(false)
  }


  return (
    <Box sx={{ margin: '2.0833vw 0', display: 'flex', width: '100%', flexDirection: 'column' }}>
      <Box>
        <MessageConfiguration
          messageList={messageList} // Pass the selected template name as a string
          setMessageList={(newList) => {
            setMessageList(newList); // Update the selected message list // Show the UserList as soon as a message is selected
          }}
          configureDashboardMessage={configureDashboardMessage}
          setConfigureDashboardMessage={setConfigureDashboardMessage}
          handleSave={handleSave}
          handleDelete={handleDelete}
          setIsMessageConfigured={setIsMessageConfigured}
          messageTemplates={messageTemplates}
          selectedEmailId={selectedEmailId}
          setSelectedEmailId={setSelectedEmailId}
          setDashboardMessage={setDashboardMessage}
          dashboardMessage={dashboardMessage}
        />
      </Box>

      {/* Conditionally show the UserList component */}
      <Box>
        {isMessageConfigured &&
          <UserList
            selectedEmailId={selectedEmailId}
            handleClearAll={handleClearAll}
            tabName={tabName}
          />}
      </Box>
    </Box>
  );
};

export default DashboardMessage;
